module.exports = __webpack_public_path__ + "static/media/k5-alt-head.70b8732c.jpg";